import React from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';

const StyledBreadCrumbs = styled(Breadcrumbs)`
  padding: ${({ theme }) => theme.spacing(0, 2)};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-color: ${({ theme }) => theme.palette.primary.textColor};

  .MuiBreadcrumbs-separator {
    color: ${({ theme }) => theme.palette.primary.textColor};
  }
`;

const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.textColor};
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;

const StyledTypographyCurrentPage = styled(Typography)`
  color: ${({ theme }) => '#0000A0'};
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;

function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
}

function CustomBreadcrumbs() {
  // const { isAuthenticated } = useAuth();
  const isUserAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const location = useLocation();
  console.log('location', location.pathname.split('/').pop());
  const currPageEndpoint = location.pathname.split('/').pop();
  let currentRoutes = [];
  const tempCurrentRoutes =
    location.pathname !== '/'
      ? location.pathname
          .split('/')
          // Filtering all the `id` placeholders from location i.e. /srm/simulator/:id/planner
          .filter((route) => !route.startsWith(':'))
      : [];
  const ignoreRoutes = ['app', 'home'];
  currentRoutes = tempCurrentRoutes.filter(
    (route) => !ignoreRoutes.includes(route)
  );
  if (currentRoutes.length > 0) {
    currentRoutes.shift();
    return (
      <StyledBreadCrumbs
        separator='›'
        aria-label='breadcrumb'
        // style={{ marginTop: 15 }}
      >
        <StyledTypography>{toTitleCase(currPageEndpoint)}</StyledTypography>
      </StyledBreadCrumbs>
    );
  }
  return null;
}

export default CustomBreadcrumbs;
